import { ColumnInfo, ColumnInfoList, DisplaySetting } from 'components/shared/display_setting'
import { TableCell } from 'components/shared/widget'
import { Equipment } from 'entities/equipment'
import { ReactNode, useMemo } from 'react'
import { Badge } from 'react-bootstrap'
import { Form } from 'utils/hooks'

export const equipmentColumnInfoList = (form?: Form<Record<string, unknown>>): ColumnInfoList => {
    return {
        tableName: '',
        values: [
            { name: 'ID', th: true, width: 50, form: form, orderAttr: 'equipment_id', searchType: { name: 'id', type: 'number' } },
            {
                name: '衛生No',
                th: true,
                width: 100,
                form: form,
                orderAttr: 'equipment_equipment_alias',
            },
            {
                name: 'カテゴリー',
                th: true,
                width: 100,
                form: form,
                orderAttr: 'equipment_equipment_category_id',
                searchType: { name: 'equipment_category', type: 'text' },
            },
            { name: '機器名称', th: true, minWidth: 250, form: form, orderAttr: 'equipment_name', searchType: { name: 'name', type: 'text' } },
            { name: '型番', th: true, width: 120, form: form, orderAttr: 'equipment_number', searchType: { name: 'number', type: 'text' } },
            {
                name: '用途',
                th: true,
                width: 120,
                form: form,
                orderAttr: 'equipment_type',
                searchType: {
                    name: 'type',
                    type: 'multiple_select',
                    selectItems: [
                        { label: 'EXTRACTION', value: 'EXTRACTION' },
                        { label: 'PCR', value: 'PCR' },
                    ],
                },
            },
            {
                name: 'おんどとりシリアル番号',
                th: true,
                width: 180,
                form: form,
                orderAttr: 'equipment_ondotori_serial_number',
                searchType: { name: 'ondotori_serial_number', type: 'text' },
            },
            {
                name: '種類',
                th: true,
                width: 180,
                align: 'center',
                form: form,
                searchType: {
                    name: 'use_temperature_ledger',
                    type: 'multiple_select',
                    selectItems: [
                        { label: '温度管理台帳', value: 'True' },
                        { label: '保守管理作業日誌', value: 'False' },
                    ],
                },
            },
        ],
    }
}

export type EquipmentTableDataProps = {
    equipment?: Equipment
    displaySetting: DisplaySetting
}

export const EquipmentTableData = ({ equipment, displaySetting }: EquipmentTableDataProps): JSX.Element => {
    if (!equipment) {
        return (
            <>
                {displaySetting.columnInfoList.values.map((_: ColumnInfo, index: number) => {
                    if (displaySetting.hiddenList.includes(index)) {
                        return <></>
                    } else {
                        return <TableCell key={index}></TableCell>
                    }
                })}
            </>
        )
    }

    const createCells = useMemo(() => {
        return (
            <>
                <TableCell>{equipment.id}</TableCell>
                <TableCell>{equipment.equipmentAlias && `衛生${equipment.equipmentAlias}`}</TableCell>
                <TableCell>{equipment.equipmentCategory?.name}</TableCell>
                <TableCell>{equipment.name}</TableCell>
                <TableCell>{equipment.number}</TableCell>
                <TableCell>
                    {(() => {
                        switch (equipment.type) {
                            case 'EXTRACTION':
                                return <Badge bg="success">EXTRACTION</Badge>
                            case 'PCR':
                                return <Badge bg="warning">PCR</Badge>
                            default:
                                return <Badge bg="secondary">指定なし</Badge>
                        }
                    })()}
                </TableCell>
                <TableCell>{equipment.ondotoriSerialNumber}</TableCell>
            </>
        )
    }, [displaySetting.hiddenList])

    return createCells.props.children.filter((_: ReactNode, index: number) => !displaySetting.hiddenList?.includes(index)).map((cell: ReactNode) => cell)
}
